import React from 'react';
import ReactDOM from 'react-dom/client';
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['br', 'en', 'es'],
    fallbackLng: 'br',
    debug: false,
    // Options for language detector
    detection: {
      order: ['path', 'localStorage', 'htmlTag'],
      caches: ['localStorage'],
    },
    react: { useSuspense: false },
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json',
    },
  })

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    <CssBaseline />
    <App />
  </>
);

reportWebVitals();
